import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "pb-2" };
const _hoisted_2 = {
    class: "alert alert-secondary",
    role: "alert"
};
const _hoisted_3 = { class: "p-2 forms_schema-card mb-2" };
const _hoisted_4 = { class: "d-flex flex-row" };
const _hoisted_5 = { class: "dev__avatar-small text-white bg-primary" };
const _hoisted_6 = { class: "ps-3 flex-fill d-flex flex-column" };
const _hoisted_7 = { class: "fw-bold" };
const _hoisted_8 = {
    key: 0,
    class: "small fst-italic"
};
const _hoisted_9 = {
    class: "d-flex flex-row border-top mt-2 pt-2",
    style: { "border-top-style": "dashed !important" }
};
const _hoisted_10 = { class: "ps-3 flex-fill d-flex flex-column small justify-content-center" };
const _hoisted_11 = { class: "d-flex flex-row mt-1" };
const _hoisted_12 = { class: "flex-fill font-family-default" };
const _hoisted_13 = { class: "d-none d-md-block" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_link = _resolveComponent("g-link");
    const _component_g_window_view = _resolveComponent("g-window-view");
    return (_openBlock(), _createBlock(_component_g_window_view, { title: _ctx.label }, {
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$tc('client.cms.forms.uploadAdditionalDocuments.note')), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (t1) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(t1.element.label1), 1),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, _toDisplayString(t1.element.label2), 1),
                                (t1.element.subLabel)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(t1.element.subLabel), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        (t1.elements)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(t1.elements, (t2) => {
                                return (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(['dev__avatar-small text-white', t2.content && t2.content.length > 0 ? 'bg-success' : 'bg-danger'])
                                    }, _toDisplayString(t2.content && t2.content.length > 0 ? 'OK' : 'Benötigt'), 3),
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("u", null, _toDisplayString(t2.element.label), 1)
                                        ]),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t2.content, (file) => {
                                            return (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                _createElementVNode("div", _hoisted_12, [
                                                    (file.fileUrl)
                                                        ? (_openBlock(), _createBlock(_component_g_link, {
                                                            key: 0,
                                                            src: file.fileUrl,
                                                            target: "_blank",
                                                            class: "font-family-default fw-bold"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(file.name), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["src"]))
                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                            _createTextVNode(_toDisplayString(file.name), 1)
                                                        ], 64))
                                                ]),
                                                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('client.cms.forms.file.info', { uploadedAt: _ctx.$utils.formatDate(file.uploadedAt, "date-time"), fileSize: _ctx.$utils.formatFileSize(file.fileSize) })), 1)
                                            ]));
                                        }), 256))
                                    ])
                                ]));
                            }), 256))
                            : _createCommentVNode("", true)
                    ]));
                }), 256))
            ])
        ]),
        _: 1
    }, 8, ["title"]));
}
